import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';

import './assets/css/App.css';
import './assets/css/Custom.css';

import { readEncryptedJsonResponse } from './common/readEncryptedJsonResponse';
import Home from './pages/Home';
import Charts from './pages/Charts';
import MarketJodiChart from './pages/MarketJodiChart';
import MarketPanaChart from './pages/MarketPanaChart';
import { useEffect, useState } from 'react';
import PrivacyPolicy from './components/PrivacyPolicy';
import HowToPlay from './pages/HowToPlay';
import GameRules from './pages/GameRules';
import StarlineChart from './pages/StarlineChart';
import JackpotChart from './pages/JackpotChart';
import StarlineResultChart from './pages/StarlineResultChart';
import JackpotResultChart from './pages/JackpotResultChart';
import InstallAppPrompt from './components/InstallAppPrompt';
import PageSeo from './components/Seo';

function App() {
  const [data, setData] = useState({});

  const host = process.env.REACT_APP_API_HOST;

  useEffect(() => {
    // Enable only when REACT_APP_DEVTOOLS_PROTECTION=true (restart/rebuild after changing .env)
    if (process.env.REACT_APP_DEVTOOLS_PROTECTION !== 'true') {
      return;
    }

    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    const handleKeyDown = (e) => {
      const key = e.key;
      const ctrlOrCmd = e.ctrlKey || e.metaKey;

      // F12
      if (key === 'F12') {
        e.preventDefault();
        return;
      }

      // Ctrl/Cmd + Shift + I / J / C
      if (ctrlOrCmd && e.shiftKey && ['i', 'I', 'j', 'J', 'c', 'C'].includes(key)) {
        e.preventDefault();
        return;
      }

      // Ctrl/Cmd + U (view source)
      if (ctrlOrCmd && (key === 'u' || key === 'U')) {
        e.preventDefault();
      }
    };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    fetch(host + '/api/home', {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        return readEncryptedJsonResponse(response);
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        console.log("Error => ", error)
      });
  }

  return (
    <Router>
      <div>
        <PageSeo />
        <Header link={data?.app_link} />

        <Routes>
          <Route path="/" exact element={<Home data={data} />} />
          <Route path="/charts" exact element={<Charts />} />
          <Route path="/charts/jodi/:id" exact element={<MarketJodiChart />} />
          <Route path="/charts/pana/:id" exact element={<MarketPanaChart />} />
          <Route path="/chart/starline" exact element={<StarlineResultChart />} />
          <Route path="/chart/starline/:id" exact element={<StarlineChart />} />
          <Route path="/chart/jackpot" exact element={<JackpotResultChart />} />
          <Route path="/chart/jackpot/:id" exact element={<JackpotChart />} />
          <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />  
          <Route path="/how-to-play" exact element={<HowToPlay number={data?.wpNumber || ""}/>} />  
          <Route path="/game-rules" exact element={<GameRules />} />  
        </Routes>
        <Footer />
        <InstallAppPrompt appLink={data?.app_link} />
      </div>
    </Router>
  );
}

export default App;
